import { StateNode, TLStateNodeConstructor } from "@tldraw/tldraw";
import { Drawing } from "../../draw/toolStates/Drawing";
import { Idle } from "../../draw/toolStates/Idle";

/** @public */
export class HighlightShapeTool extends StateNode {
  static override id = "customHighlight";
  static override initial = "idle";
  static useCoalescedEvents = true;
  static override children(): TLStateNodeConstructor[] {
    return [Idle, Drawing];
  }
  static override isLockable = false;
  override shapeType = "customHighlight";

  override onExit() {
    const drawingState = this.children!["drawing"] as Drawing;
    drawingState.initialShape = undefined;
  }
}
